import axios from "axios";
import routes from "../app/routes";

export const editCoachPoolActions = {
  loadCoaches: (dispatch) => {
    axios.get(routes.api.coaches.index).then((resp) => {
      dispatch({ type: "loadCoaches", coaches: resp.data.data });
    });
  },
  editCoachPool: (id) => {
    document.location.href = routes.api.coach_pools.edit(id);
  },
  listCoachPools: () => {
    document.location.href = routes.api.coach_pools.list;
  },
  showCoachPool: (id) => {
    document.location.href = routes.api.coach_pools.show(id);
  },
  updateCoachPool: (dispatch, coachPool, params, callback, errorCallback) => {
    axios
      .put(routes.api.coach_pools.update(coachPool.id), params)
      .then((resp) => {
        dispatch({ type: "successUpdateCoachPool" });
        callback();
      })
      .catch((error) => {
        if (error.response && error.response.status == 422) {
          errorCallback();

          let data = [];
          error.response.data.errors.forEach((error) => {
            data.push(error.detail);
          });
          dispatch({ type: "errorUpdateCoachPool", errors: data.join(".") });
        }
      });
  },
  updateCoachPoolName: (dispatch, name) => {
    dispatch({ type: "updateCoachPoolName", name: name });
  },
  updateCoachPoolDefault: (dispatch, isDefault) => {
    dispatch({ type: "updateCoachPoolDefault", default: isDefault });
  },
  updateCoachPoolSelectedCoach: (dispatch, coachId, status) => {
    dispatch({
      type: "updateCoachPoolSelectedCoach",
      coachId: coachId,
      status: status,
    });
  },
  selectAllRecords: (dispatch, status) => {
    dispatch({
      type: "selectAllRecords",
      status: status,
    });
  },
  selectAllFilteredRecords: (dispatch, status, recordIds) => {
    dispatch({
      type: "selectAllFilteredRecords",
      status: status,
      recordIds: recordIds,
    });
  },
  clearSelectedAll: (dispatch) => {
    dispatch({
      type: "clearSelectedAll",
    });
  },
};
